import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  Brain, 
  Heart, 
  Twitter, 
  Github, 
  Linkedin,
  ArrowRight,
  ExternalLink
} from 'lucide-react';

const Footer = () => {
  const [email, setEmail] = useState('');
  const currentYear = new Date().getFullYear();

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    alert('Newsletter subscription coming soon!');
    setEmail('');
  };

  return (
    <footer className="bg-black/20 backdrop-blur-md border-t border-white/10">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-2 group hover-lift">
              <Brain className="h-8 w-8 text-transparent bg-gradient-to-r from-purple-300 to-pink-300 bg-clip-text" />
              <span className="text-xl font-bold gradient-text">The Most Useless</span>
            </Link>
            <p className="text-gray-300">
              Your daily source of fascinating but completely useless knowledge. Perfect for procrastination!
            </p>
            <div className="flex items-center space-x-4 text-gray-400">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-purple-300 transition hover-lift">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="hover:text-purple-300 transition hover-lift">
                <Github className="h-5 w-5" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="hover:text-purple-300 transition hover-lift">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 gradient-text">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/dashboard" className="text-gray-300 hover:text-white transition">Dashboard</Link>
              </li>
              <li>
                <Link to="/login" className="text-gray-300 hover:text-white transition">Sign In</Link>
              </li>
              <li>
                <Link to="/register" className="text-gray-300 hover:text-white transition">Create Account</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 gradient-text">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-gray-300 hover:text-white transition flex items-center">
                  Privacy Policy
                  <ExternalLink className="h-4 w-4 ml-1" />
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-300 hover:text-white transition flex items-center">
                  Terms of Service
                  <ExternalLink className="h-4 w-4 ml-1" />
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-white transition flex items-center">
                  FAQ
                  <ExternalLink className="h-4 w-4 ml-1" />
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 gradient-text">Stay Updated</h3>
            <p className="text-gray-300 mb-4">
              Get daily useless facts delivered to your inbox!
            </p>
            <form onSubmit={handleSubscribe} className="space-y-2">
              <div className="flex">
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 px-4 py-2 bg-white/10 border border-white/20 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent text-white placeholder-gray-400"
                  required
                />
                <button
                  type="submit"
                  className="gradient-bg text-white px-4 py-2 rounded-r-lg hover:opacity-90 transition flex items-center"
                >
                  <ArrowRight className="h-5 w-5" />
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-wrap items-center justify-center text-gray-300 text-sm gap-x-2">
            <span>© {currentYear}</span>
            <span>|</span>
            <span>The Most Useless</span>
            <span>|</span>
            <span className="flex items-center">
              Made with <Heart className="h-4 w-4 text-red-500 mx-1" /> by UselessTeam
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;